import villaLogo from '../assets/Navbar/CINNAMON MANTRA (1).png';

function Footer() {
  return (
    <footer className="flex flex-col items-center bg-white px-6 pb-[30px] pt-[49px] text-center text-green-deep">
      <div className="flex items-center gap-3 text-left">
        <img className="h-[43px] w-[43px] object-contain" src={villaLogo} alt="Cinnamon Mantra Ayurveda Villa" />
        <div className="flex flex-col gap-[3px]">
          <strong className="font-serif text-lg font-medium">Cinnamon Mantra</strong>
          <span className="text-[8px] tracking-[.15em] text-[#777d70]">AYURVEDA VILLA · SRI LANKA</span>
        </div>
      </div>
      <p className="mb-[27px] mt-[19px] text-[11px] tracking-[.04em] text-[#777d70]">スリランカの自然とアーユルヴェーダに包まれる、穏やかな滞在。</p>
      <small className="w-full max-w-[1180px] border-t border-[#e7eadf] pt-[19px] text-[9px] tracking-[.04em] text-[#85897e]">© {new Date().getFullYear()} Cinnamon Mantra Ayurveda Villa</small>
    </footer>
  );
}

export default Footer;
